module.exports = __webpack_public_path__ + "static/media/nr.434904de.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/nr.svg
// module id = 2179
// module chunks = 0